import { c as _c } from "react/compiler-runtime";
import { isVaultDataDecrypted, isVaultDataText } from '@onefootprint/core';
import type { DataIdentifier, Entity } from '@onefootprint/request-types/dashboard';
import { EncryptedCell } from '@/components';
import hasDataIdentifier from '@/utils/has-data-identifier';
import Field from '../../../../../field';
import ssnFormatter from './utils/ssn-formatter';
export type SSNType = {
  di: DataIdentifier;
  entity: Entity;
};
const SSN = t0 => {
  const $ = _c(3);
  const {
    di,
    entity
  } = t0;
  let t1;
  if ($[0] !== di || $[1] !== entity) {
    t1 = hasDataIdentifier(entity, di) ? <Field di={di} entity={entity} renderValue={value => {
      if (isVaultDataDecrypted(value) && isVaultDataText(value)) {
        return <div className="text-body-2 text-primary" data-dd-privacy="mask">{di === "id.ssn4" ? value : ssnFormatter(value)}</div>;
      }
      return <EncryptedCell />;
    }} /> : null;
    $[0] = di;
    $[1] = entity;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
export default SSN;